document.addEventListener("turbolinks:load", function() {
  count_coupons()
  popover()
  var coupon_card_body = document.getElementById("coupon_card_body");
  var show_tickets_button = document.getElementById("show_tickets_button");
  if(coupon_card_body && show_tickets_button){
    show_tickets_button.addEventListener("click",show_tickets);
  }
  if ( window.coupon_ids && window.referrer_code && window.referrer_environment && window.order_id ) {
    window.coupon_ids.forEach(function (coupon_id) {
      add_coupon_to_localstorage(coupon_id, window.referrer_code, window.referrer_environment, window.order_id);
    });
  }
})

function popover(){
  $(function () {
    $('[data-toggle="popover"]').popover()
  })
  $('.popover-dismiss').popover({
    trigger: 'focus'
  })
}


function count_coupons(){
  mobility_coupons = JSON.parse(localStorage.getItem("mobility_coupons")) || [];
  if (document.getElementById('ticket_length')) {
    document.getElementById('ticket_length').innerHTML = mobility_coupons.length;
  }
}

function show_tickets(){
  remove_childs_from_coupon_card_body()
  get_coupons_from_localstorage()
}

function remove_childs_from_coupon_card_body(){
  var last_child_coupon_card_body = coupon_card_body.lastElementChild;
  while (last_child_coupon_card_body) {
    coupon_card_body.removeChild(last_child_coupon_card_body);
    last_child_coupon_card_body = coupon_card_body.lastElementChild;
  }
}

function add_coupon_to_localstorage(couponid, referrer_code, referrer_environment, order_id){
  mobility_coupons = JSON.parse(localStorage.getItem("mobility_coupons")) || [];
  var value_found = false;
  if (couponid && referrer_code && referrer_environment && order_id) {
    for (var index = 0; index < mobility_coupons.length; index++){
      if(mobility_coupons[index].couponid == couponid){
        value_found = true;
        break;
      }
    }
    if (value_found == false){
      mobility_coupons.push({couponid: couponid, referrer_code: referrer_code, referrer_environment: referrer_environment, order_id: order_id});
      localStorage.setItem("mobility_coupons", JSON.stringify(mobility_coupons));
      count_coupons();
    }
  }
}

function remove_coupon_from_localstorage(couponid){
  mobility_coupons = JSON.parse(localStorage.getItem("mobility_coupons")) || [];
  var found_index = -1;
  for (var index = 0; index < mobility_coupons.length; index++){
    if(mobility_coupons[index].couponid == couponid){
      found_index = index;
      break;
    }
  }
  if (found_index > -1){
    mobility_coupons.splice(index, 1);
    localStorage.setItem("mobility_coupons", JSON.stringify(mobility_coupons));
    count_coupons();
  }
}

function create_html_element(element_tag_name, classes, text, attribute_name, attribute_value){
  var html_element = document.createElement(element_tag_name);
  classes_array = classes.split(" ");
  classes_array.forEach(css_class => html_element.classList.add(css_class));
  if (text){
    html_element.innerHTML = text;
  }
  if (attribute_name && attribute_value && attribute_name != "" && attribute_value != ""){
    html_element.setAttribute(attribute_name, attribute_value);
  }
  return html_element;
}

function create_card_element(product_name, environment, couponid, referrer_code, ticket_description, order_id){
  const div_card_mb = create_html_element("div", "card mb-3 coupon-card");
  const div_card_body = create_html_element("div", "card-body");
  const div_dflex_justify_content = create_html_element("div", "d-flex justify-content-between");
  const div_dflex_flex_row = create_html_element("div", "d-flex flex-row align-items-center");
  const div_ms = create_html_element("div", "ms-3");
  const h5_product_name = create_html_element("h5", "product-name text-center", product_name);
  const p_small_mb = create_html_element("p", "small mb-0", ticket_description);
  const div_dflex_flex_row_2 = create_html_element("div","d-flex flex-row align-items-center");
  const div_style = create_html_element("div","w-80");
  const btn_activate_coupon = create_html_element("a","mb-0 btn btn-primary buttons_card", "Download Ticket", "href", window.download_link+'/'+order_id);
  if(environment == "test"){
    const div_rippon = create_html_element("div","coupon-ribbon","Test");
    div_card_mb.appendChild(div_rippon);
  }
  div_card_mb.appendChild(div_card_body);
  div_card_body.appendChild(div_dflex_justify_content);
  div_dflex_justify_content.appendChild(div_dflex_flex_row);
  div_dflex_flex_row.appendChild(div_ms);
  div_ms.appendChild(h5_product_name);
  div_ms.appendChild(p_small_mb);
  div_dflex_justify_content.appendChild(div_dflex_flex_row_2);
  div_dflex_flex_row_2.appendChild(div_style);
  div_style.appendChild(btn_activate_coupon);
  coupon_card_body.appendChild(div_card_mb);
}

function check_coupon(couponid, referrer_code, referrer_environment, order_id){
  fetch(window.mobilitybox_api_url + "/v7/ticketing/coupons/"+couponid+'.json')
    .then(response => response.json())
    .then(json => {
      if (json.id){
        if(json.activated == true){
          remove_coupon_from_localstorage(couponid);
        } else {
          create_card_element(get_ticket_name(json.product.ticket_type,json.product.customer_type,json.area.properties.city_name), referrer_environment, couponid, referrer_code, json.product.local_ticket_name, order_id);
          add_coupon_to_download_all_button(couponid)
        }
      } else {
        console.log("coupon konnte nicht geladen werden couponid: "+couponid);
      }
    })
}

function get_coupons_from_localstorage(){
  mobility_coupons = JSON.parse(localStorage.getItem("mobility_coupons")) || [];
  mobility_coupons.forEach(coupon => check_coupon(coupon.couponid,coupon.referrer_code, coupon.referrer_environment, coupon.order_id));
}

function add_coupon_to_download_all_button(coupon_id) {
  dowload_all_url = document.getElementById("download_all_button").href = new URL(document.getElementById("download_all_button").href)
  query = dowload_all_url.searchParams
  query.set("mobilitybox_coupon_ids", (query.get("mobilitybox_coupon_ids") || "") + ","+coupon_id )
  dowload_all_url.search = query.toString()
  document.getElementById("download_all_button").href = dowload_all_url
}

function get_ticket_name(mobilitybox_ticket_type, mobilitybox_customer_type, mobilitybox_area_name){
    product_ticket_type = (mobilitybox_ticket_type == "day") ? "Tagesticket" : (mobilitybox_ticket_type == "single") ? "Einzelticket" : ""
    product_customer_type = (mobilitybox_customer_type == "child") ? "Kind" : ""
    return `${product_ticket_type} ${mobilitybox_area_name} ${product_customer_type}`
}
